module.exports = __webpack_public_path__ + "38b17c60ba71b3aa71c29b0493e6607d.woff";